import { createClient, Interceptor } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'
import { AuthService } from '../api/ga/config_manager/auth/auth_pb'
import { UsersService } from '../api/ga/config_manager/user/user_pb'
import { CurrencyService } from '../api/ga/config_manager/currency/currency_pb'
import { CasinoKeyService } from '../api/ga/config_manager/casinokey/casinokey_pb'
import { CasinosConfigService } from "../api/ga/config_manager/casinosconfig/casinos_config_pb";
import { ConfigDeliveryService } from "../api/ga/config_manager/configdelivery/config_delivery_pb";
import { ProvidersConfigService } from '../api/ga/config_manager/providersconfig/providers_config_pb'
import { UserScopeService } from '../api/ga/bo/user_scope/user_scope_pb'

const logger: Interceptor = (next) => async (req) => {
  console.log(`sending message to ${req.url}`)
  return await next(req)
}

const auth: Interceptor = (next) => async (req) => {
  try {
    const sessionToken = window.localStorage.getItem('sessionToken')
    if (sessionToken) {
      req.header.append(
        'X-Session-ID',
        JSON.parse(sessionToken ? sessionToken : '')
      )
    }
  } catch (e) {}
  return await next(req)
}

export const transport = createConnectTransport({
  // for local debug live games
  // baseUrl: "http://localhost:5566",
  baseUrl: window.location.origin,
  // send/receive messages as binary protobuf instead of JSON
  // useBinaryFormat: true,
  // interceptors: [logger, auth],
  interceptors: [auth],
})

export const authService = createClient(AuthService, transport)
export const userScopeService = createClient(UserScopeService, transport)
export const userService = createClient(UsersService, transport)
export const currencyService = createClient(CurrencyService, transport)
export const casinosConfig = createClient(CasinosConfigService, transport)
export const providersConfig = createClient(ProvidersConfigService, transport)
export const casinoKeyService = createClient(CasinoKeyService, transport)
export const configDeliveryService = createClient(ConfigDeliveryService, transport)